/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

// TODO: Log to New Relic Logs API
var debug = function (message, attrs) {
    if (attrs === void 0) { attrs = {}; }
    return console.debug(message, attrs);
};
var info = function (message, attrs) {
    if (attrs === void 0) { attrs = {}; }
    return console.info(message, attrs);
};
var warn = function (message, attrs) {
    if (attrs === void 0) { attrs = {}; }
    return console.warn(message, attrs);
};
var error = function (err, attrs) {
    if (attrs === void 0) { attrs = {}; }
    if (!(err instanceof Error)) {
        err = new Error(String(err));
    }
    attrs = __assign(__assign({}, attrs), { ErrorStack: err.stack });
    var nextErr = err;
    if (nextErr.isAxiosError && nextErr.response && nextErr.response.config) {
        var url = void 0;
        try {
            url = new URL(nextErr.config.url || '', nextErr.config.baseURL || undefined);
        }
        catch (nextErr) {
            debug('Unable to parse nextErr error');
        }
        attrs = __assign(__assign({}, attrs), { RequestMethod: null != nextErr.config.method ? nextErr.config.method.toUpperCase() : undefined, RequestPath: url && url.pathname, RequestUrl: url && url.toString(), ResponseData: nextErr.response.data, ResponseStatus: nextErr.response.status });
    }
    if ('undefined' !== typeof window && window.newrelic) {
        window.newrelic.noticeError(nextErr, attrs);
    }
    console.error(nextErr.message, attrs);
};
var apiError = function (err, attrs) {
    if (attrs === void 0) { attrs = {}; }
    // Ignore client errors
    var nextErr = err;
    if (nextErr.isAxiosError && nextErr.response && nextErr.response.status < 500) {
        return;
    }
    return error(nextErr, attrs);
};
var index = {
    debug: debug,
    info: info,
    warn: warn,
    error: error,
    apiError: apiError
};

export default index;
export { apiError, debug, error, info, warn };
